import React from 'react';
import { Icon } from 'Components';
import Heading from 'LearningManager/components/Heading';
import ConfigureSettingsCard from 'LearningManager/components/Review/ConfigureSettingsCard';
import { useStepper } from 'LearningManager/hooks/Stepper.context';
import styles from 'LearningManager/styles/CustomSetup.module.scss';

const orderingItems = [
	{
		id: 1,
		path: 'Basic Learning Path',
		learnerGroup: 'Staff'
	},
	{
		id: 2,
		path: 'Basic Learning Path + Intermediate Learning Path',
		learnerGroup: 'Managers'
	},
	{
		id: 3,
		path:
			'Basic Learning Path + Intermediate Learning Path + Advanced Learning Path',
		learnerGroup: 'Leadership and IT'
	}
];

const Review: React.FC = () => {
	const {
		draft: { configure }
	} = useStepper();

	return (
		<div id="lms-ca-quick-review" className={styles.review}>
			<Heading
				title="Review & Confirm"
				subHeading="Review the configuration below and restart the assignment"
			/>

			<div
				id="lms-ca-quick-review-ordering"
				className={styles.reviewSection}
			>
				<div className={styles.reviewSectionTitle}>Ordering</div>
				<div className={styles.courseList}>
					{orderingItems.map((item) => (
						<div
							key={item.id}
							id={`lms-ca-quick-review-ordering-item-${item.id}`}
							className={styles.courseItem}
						>
							<Icon
								type="roleOptIcon"
								role="img"
								className={styles.blueIcon}
							/>
							<div className={styles.courseItemRight}>
								<div className={styles.courseLabel}>
									{item.path}
								</div>
								<div className={styles.infoTag}>
									{item.learnerGroup}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>

			<div
				id="lms-ca-quick-review-audience"
				className={styles.reviewSection}
			>
				<div className={styles.reviewSectionTitle}>
					Full Campaign Audience
				</div>
				<div className={styles.summaryCard}>
					<div>
						<div className={styles.mutedLabel}>
							Assigned Learners
						</div>
						<div className={styles.summaryValue}>Role</div>
					</div>
					<div>
						<div className={styles.mutedLabel}>Roles</div>
						<div className={styles.summaryValue}>
							Staff, Managers, Leadership and IT
						</div>
					</div>
				</div>
			</div>

			<div
				id="lms-ca-quick-review-configure"
				className={styles.reviewSection}
			>
				<div className={styles.reviewSectionTitle}>
					Configure Settings
				</div>
				<ConfigureSettingsCard configure={configure} />
			</div>
		</div>
	);
};

export default Review;
